import React from "react";
import blackLogo from "./images/logoBlack.png";


export default function TempHome() {
	return (
		<div className="temp-home-container">
			<h1>THE BRAIN</h1>

			<a href="/brain" style={{display:"flex", alignSelf:"center"}}>
				<img alt="Brain Logo, redirecting to brain page" className="home-logo" src={blackLogo} />
			</a>
			<h2>AI Powered, Data Driven.</h2>
		</div>
	);
}
